import React, { useState, useEffect, Fragment, useRef } from 'react'
import { Table, Modal, message, Divider, Button, Switch, Popconfirm } from "antd";
import { DownloadOutlined, PlusOutlined, UploadOutlined, EditFilled, DeleteOutlined } from '@ant-design/icons';
import InspectApi from '@api/inspect'
import { stationApi, } from "@api/newApi";
import SearchForm from '@components/SearchForm'
import HandleButton from '@components/HandleButton'
import Title from '@/components/Title'
import { connect } from 'react-redux'
import moment from 'moment';
import { setStateSearchParams } from '@store/actions/common'
import { getStationData } from '@utils/common'
import AddModel from './add'
// import './style.scss'

const types = ['未删除', '已删除']
const InspectModel = (props) => {
  const [loading, setLoading] = useState(false)
  const [loadBtn, setLoadBtn] = useState(false)
  const [data, setData] = useState([]) // 表格数据
  const [deleteVisible, setDelVisible] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [totalData, setTotalData] = useState({})
  const [editTitle, setEditTitle] = useState('新建模版')
  const [rowParams, setRowParams] = useState()
  // 查询参数
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    name: ''
  })
  const [total, setTotal] = useState(0)


  // 搜索
  // const [inputList] = useState([{
  //   label: '站点:',
  //   name: "stationId",
  //   message: "请输入部门ID",
  //   span: 8,
  //   labelCol: 6
  // }])
  const [selectList, setSelectList] = useState()

  const [stationData, setStationData] = useState()

  useEffect(() => {
    getStationList()
    return () => { }
  }, [])
  // 获取厂站列表
  const getStationList = () => {
    // let data = getStationData(props.userInfo.stationIds, props.userInfo.stationAliasName)
    setSelectList([
      {
        attr: { allowClear: true },
        label: '状态:',
        name: "status",
        message: "请选择状态",
        options: [{ title: '停用', value: 0, checked: false }, { title: '启用', value: 1, checked: false }],
        span: 8,
        labelCol: 6
      },
    ])
    setStationData(data)
  }

  useEffect(() => {
    listByRole()
    return () => { }
  }, [searchParams])

  const listByRole = () => {
    setLoading(true)
    // const statinIds = userInfo.stationIds ? userInfo.stationIds.split(",") : []
    InspectApi.query({ ...searchParams, }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setData(res.data.data || [])
        setTotal(res.total)
      }
    })
  }

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    console.log(paramsObj, 'paramsObj')
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: paramsObj.stationId && paramsObj.stationId * 1
    }
    setSearchParams(params)
  }

  /**
  * 删除规则
  */
  const deletes = (id) => {
    setLoadBtn(true)
    InspectApi.delete(id).then(res => {
      setLoadBtn(false)
      if (res.status == 0) {
        setDelVisible(false)
        setRowParams(null)
        listByRole()
        message.success("删除成功！")
      }
    }).catch(err => {
      setLoadBtn(false)
    })
  }

  const cancel = () => {
    setDelVisible(false)
    // setParams({})
  }
  // 改变状态
  const handleConfirm = (info) => {
    if (info.status) {
      InspectApi.disenable({ id: info.id }).then(res => {
        if (res.status === '0') {
          message.success('修改成功')
          listByRole()
        }
      })
    } else {
      InspectApi.enable({ id: info.id }).then(res => {
        if (res.status === '0') {
          message.success('修改成功')
          listByRole()
        }
      })
    }
  }

  const btnList = [{
    title: "新增",
    type: 'primary',
    icon: <PlusOutlined />,
    onClick: () => {
      setEditVisible(true)
      setRowParams(null)
    }
  },
  {
    title: "导入模版",
    icon: <UploadOutlined />,
    type: 'upload',
    props: {
      // name: 'file',
      // action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
      // headers: {
      //   authorization: 'authorization-text',
      // },
      beforeUpload(file) {
        return false
      },
      accpet: ".xlsx",
      action: '#',
      showUploadList: false,
      maxCount: 1,
      onChange(info) {
        // if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList);
        // }
        let name = info.file.name;
        // console.log(name, name.substring(name.length - 4))
        if (name.indexOf('.xlsx') < 0) {
          message.warning('所选文件的格式不正确！');
          return false;
        }
        let formData = new FormData();
        formData.append('file', info.file)
        InspectApi.batchImportTemplate(formData, {
          'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryYmNa307cOmXILq7Z',
        }).then(res => {
          if (res.status === '0') {
            message.success('上传成功')
            listByRole()
          }
        })
        // if (info.file.status === 'done') {
        //   message.success(`${info.file.name} file uploaded successfully`);
        // } else if (info.file.status === 'error') {
        //   message.error(`${info.file.name} file upload failed.`);
        // }
      },
    }
  }]

  const columns = [
    {
      title: '模版名称',
      dataIndex: 'templateName',
      align: 'center',
      key: 'templateName',
    },
    {
      title: '是否删除',
      dataIndex: 'deleteFlag',
      align: 'center',
      key: 'deleteFlag',
      render: (obj, record) => {
        return <span> {types[obj]}</span>
      }
    },
    {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      key: 'status',
      render: (obj, record) => {
        return <span style={{ color: obj !== 0 ? 'green' : 'red' }}> {obj !== 0 ? '启用' : '禁用'}</span>
      }
    },

    {
      title: '创建人',
      dataIndex: 'createBy',
      align: 'center',
      key: 'createBy',
    },

    {
      title: '创建时间',
      dataIndex: 'createAt',
      align: 'center',
      key: 'createAt',
      render: (obj) => {
        if (obj) {
          return (
            moment(obj).format('YYYY-MM-DD HH:mm:ss')
          )
        }
      }
    },
    {
      title: '修改人',
      dataIndex: 'updateBy',
      align: 'center',
      key: 'updateBy',
    },

    {
      title: '修改时间',
      dataIndex: 'updateAt',
      align: 'center',
      key: 'updateAt',
      render: (obj) => {
        if (obj) {
          return (
            moment(obj).format('YYYY-MM-DD HH:mm:ss')
          )
        }
      }
    },
    {
      title: '备注',
      dataIndex: 'remark',
      align: 'center',
      key: 'remark',
      width: '200px',
    },

    {
      title: '操作',
      key: 'operation',
      width: '200px',
      fixed: 'right',
      render: (obj, record) => {
        return (
          <>
            <Popconfirm
              title={`确定要${!obj.status ? '启用' : '禁用'}模版吗？`}
              onConfirm={() => handleConfirm(record)}
              // onCancel={cancel}
              okText="确定"
              cancelText="取消"
            >
              <Button size='small' type="primary">{!obj.status ? '启用' : '禁用'}</Button>
            </Popconfirm>
            <Button
              style={{ marginLeft: '5px' }}
              onClick={() => {
                setEditVisible(true)
                setRowParams(record)
              }
              }
              size='small'
              type='primary'>编辑
            </Button>
            <Button
              style={{ marginLeft: '5px' }}
              onClick={() => {
                setDelVisible(true)
                setRowParams(record)
              }
              }
              size='small'
              type='primary'>删除
            </Button>
          </>
        )
      }
    }
  ]
  return (
    <div className='baseContent boundary'>
      <div className='title'>
        {/* <Title title="站点列表" style={{ marginLeft: '24px' }}></Title> */}
        <div style={{ marginLeft: '24px' }}>
          <SearchForm searchParams={searchParams} span={6} selectList={selectList} onSearch={search} />
        </div>
        <HandleButton btnList={btnList} btnStyle={{ padding: '0 24px 20px', textAlign: 'right' }} />
        <div >
          <Table
            className='Table'
            scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={data}
            rowKey={record => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: total => `共${total}条数据`,
              total: total
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>

        {
          deleteVisible &&
          <Modal
            title='删除站点'
            width={420}
            open={deleteVisible}
            onCancel={cancel}
            confirmLoading={loadBtn}
            onOk={() => deletes(rowParams.id)}>
            <div style={{ textAlign: 'center', color: "red" }}>
              <p>{`确定要删除巡检模版【${rowParams.templateName}】吗？`}</p>
            </div>
          </Modal>
        }
        {editVisible && <AddModel stationData={stationData} visible={editVisible} title={editTitle} formData={rowParams} cancel={(bool) => { setEditVisible(false); bool && listByRole() }} />}
      </div>
    </div >
  )
}

const mapStateToProps = state => {
  return {
    ...state.Common
  }
};

export default connect(mapStateToProps)(InspectModel)
